import { render, staticRenderFns } from "./estadisticas.vue?vue&type=template&id=b7c1dfe8&scoped=true"
import script from "./estadisticas.vue?vue&type=script&lang=js"
export * from "./estadisticas.vue?vue&type=script&lang=js"
import style0 from "./estadisticas.vue?vue&type=style&index=0&id=b7c1dfe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c1dfe8",
  null
  
)

export default component.exports